function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExecutionProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#accddc",
      strokeWidth: 1.05263162,
      fillOpacity: 1
    },
    d: "M40 13H30V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d4e9fd",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 11.88947392,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M382.171 423.053H128.529V90.147h174.379l79.263 79.263z",
    transform: "translate(-6.215 -8.373) scale(.12616)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aad4fc",
      fillOpacity: 1,
      strokeWidth: 11.88947392,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "M382.171 169.41h-79.263V90.147Z",
    transform: "translate(-6.215 -8.373) scale(.12616)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "m40 21-7.938-2.168 4.079-7.145-2.828-2.832-6.836 3.903L24 5h-4l-2.375 7.438-6.938-3.579-2.828 2.829 3.579 6.937L4 21v4l7.438 2.375-3.579 6.938 2.829 2.828 6.937-3.578L20 41h4l2.375-7.438 6.938 3.579 2.828-2.828-3.735-7.239L40 25ZM22 31a8 8 0 1 1 0-16 8 8 0 0 1 0 16z",
    transform: "translate(-1.111 14.111) scale(.77778)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78909c"
    },
    d: "M22 10c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13Zm0 20a7.001 7.001 0 0 1 0-14 7.001 7.001 0 0 1 0 14z",
    transform: "translate(-1.111 14.111) scale(.77778)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutionProfile);
export default __webpack_public_path__ + "static/media/executionProfile.44e8e34b68aeebd4306d69eb55f752f7.svg";
export { ForwardRef as ReactComponent };